import { setError } from '@redux/slices/global';

import store from '../index';

const ignoredErrors = [401, 409, 422];

export default () => (next) => (action) => {
    const { error, payload } = action;
    const status = payload?.status;
    const isIgnoredError = payload && ignoredErrors.includes(status);

    if (error && !isIgnoredError) store.dispatch(setError({ code: status }));

    return next(action);
};
